import { trycatch } from './util';

export const log = (...args) => console.log(...args);
log.error = (...args) => console.error(...args);
log.handle = (name, fn) => trycatch(fn).catch(e => log.error("While performing " + name, e));

export default log;


// WEBPACK FOOTER //
// ./src/api/log.js